import 'json.date-extensions';

console.log("EXTENSIONS LOADED");
JSON.useDateParser();